import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import FirstCard from './FirstCard';
import SecondCard from './SecondCard';
import HeroContext from '../../PageContext';
import RightPolygons from './RightPolygons';
import LeftPolygons from './LeftPolygons';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      '& a': {
        width: '100%',
      },
    },
    [theme.breakpoints.down('480')]: {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  rightContent: {
    zIndex: 1,
    position: 'relative',
    [theme.breakpoints.down('480')]: {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
}));

function FeaturedResources() {
  const classes = useStyles();
  const { clientInfo, featuredResources, sendMixpanelEvent } = useContext(
    HeroContext,
  );
  const { heroGraphics = 'Hide' } = clientInfo;
  if (_isEmpty(featuredResources)) return null;
  const showGraphics = heroGraphics === 'Show';
  const clickHandler = (title, props) => {
    sendMixpanelEvent(title, props);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={5} className={classes.root}>
        {showGraphics && <LeftPolygons />}
        <Grid container justify="flex-end">
          {featuredResources.slice(0, 1).map(item => (
            <FirstCard
              data={item}
              key={item.slug}
              clickHandler={clickHandler}
            />
          ))}
        </Grid>
      </Grid>
      <Grid item xs={7} className={classes.rightContent}>
        {showGraphics && <RightPolygons />}
        <Grid container direction="column">
          {featuredResources.slice(1, 4).map(item => (
            <SecondCard
              data={item}
              key={item.slug}
              clickHandler={clickHandler}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default FeaturedResources;
